// @ts-nocheck
import { Navigate } from 'react-router-dom';

import { useAppSelector } from '../redux/store';
import { userSliceSelectors } from '../redux/user/user.selector';
import { SideBarRoutes } from './types/SideBarRoutes.enum';

interface AtiraRouteProps {
  component: React.ReactNode;
  redirect?: string;
}

/** Makes sure only NON logged-in users can go to props.component */
export const AtiraRouteNotLoggedIn: React.FC<AtiraRouteProps> = ({
  component,
  redirect,
}) => {
  const loggedInUserId = useAppSelector(
    userSliceSelectors.selectLoggedInUserId,
  );
  const isLoggedIn = Boolean(loggedInUserId);

  if (isLoggedIn) {
    return (
      <Navigate
        to={redirect || SideBarRoutes.DASHBOARD}
        replace
        state={{ from: window.location.href }}
      />
    );
  }

  return component;
};
